export interface Bonus {
  number: string
  title: string
  tagline: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Mapa Rápido de Decisión',
    tagline: 'Elegí la sesión correcta en menos de 5 minutos.',
    image:
      'https://cdn.magicpatterns.com/uploads/mhfeB5jWoqxbEXyVXhSpvb/mockup-mapa-rapido-de-decision.webp',
    alt: 'Portada del Bono 1: Mapa rápido de decisión, con un entrenador y su grupo en la pista.',
  },
  {
    number: '2',
    title: 'Correcciones Express',
    tagline: '40 errores técnicos y la frase exacta para corregirlos.',
    image:
      'https://cdn.magicpatterns.com/uploads/522sEoGZQ7TtrqugtuYZZR/mockup-manual-de-correcciones-express.webp',
    alt: 'Portada del Bono 2: Manual de correcciones express, con un velocista en plena aceleración.',
  },
  {
    number: '3',
    title: 'Adaptación de Grupos Mixtos',
    tagline: 'Una misma sesión en 3 niveles: base, desarrollo y rendimiento.',
    image:
      'https://cdn.magicpatterns.com/uploads/oxhPhwZWHbFFNWfK4w7JnS/mockup-guia-de-adaptacion-para-grupos-mixtos.webp',
    alt: 'Portada del Bono 3: Guía de adaptación para grupos mixtos, con conos sobre la pista al atardecer.',
  },
  {
    number: '4',
    title: 'Calentamientos Específicos',
    tagline: '8 protocolos por disciplina, en versión corta y completa.',
    image:
      'https://cdn.magicpatterns.com/uploads/wFPhzwD4eSwRxek42u9XB7/mockup-protocolos-de-calentamiento-especifico.webp',
    alt: 'Portada del Bono 4: Protocolos de calentamiento específico, con un atleta en posición de arranque.',
  },
  {
    number: '5',
    title: 'Consignas Técnicas',
    tagline: '50+ “cues” verbales para cambios mecánicos inmediatos.',
    image:
      'https://cdn.magicpatterns.com/uploads/27aTBmcr4fu2Tx512q3aXb/mockup-biblioteca-de-consignas-tecnicas.webp',
    alt: 'Portada del Bono 5: Biblioteca de consignas técnicas, con tacos de salida sobre la pista.',
  },
]

/** Resumen corto usado en la tabla de valor. */
export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bono 1 — Mapa de Decisión', value: '$19' },
  { label: 'Bono 2 — Correcciones Express', value: '$17' },
  { label: 'Bono 3 — Adaptación Grupos Mixtos', value: '$15' },
  { label: 'Bono 4 — Calentamientos Específicos', value: '$14' },
  { label: 'Bono 5 — Consignas Técnicas', value: '$12' },
]
